// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__qdX_Y","boxTitle":"Qualiphy_boxTitle__1-v7D","box":"Qualiphy_box__3Wptl","toggleWrap":"Qualiphy_toggleWrap__17Toh"};